import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-user-profile-menu',
  templateUrl: './user-profile-menu.component.html',
  styleUrl: './user-profile-menu.component.css',
  standalone: false,
})
export class UserProfileMenuComponent {
  @Input() userName: string = 'User';
  @Input() userRole: string = 'Staff';
  @Input() userAvatar?: string;

  @Output() logout = new EventEmitter<void>();
  @Output() profileClick = new EventEmitter<void>();
  @Output() settingsClick = new EventEmitter<void>();

  menuOpen = false;

  get userInitials(): string {
    const parts = this.userName.split(' ');
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    }
    return this.userName.substring(0, 2).toUpperCase();
  }

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  closeMenu(): void {
    this.menuOpen = false;
  }

  onProfileClick(): void {
    this.profileClick.emit();
    this.closeMenu();
  }

  onSettingsClick(): void {
    this.settingsClick.emit();
    this.closeMenu();
  }

  onLogout(): void {
    this.logout.emit();
    this.closeMenu();
  }
}
